<div class="container mx-auto space-y-6">
  <!-- Page Header -->
  <div
    class="flex flex-wrap items-center justify-between gap-4 pb-4 border-b border-base-300"
  >
    <div>
      <h2 class="text-2xl font-bold text-base-content flex items-center gap-2">
        <i class="fa-solid fa-compass text-primary"></i>
        Explore Live Classes
      </h2>
      <p class="text-sm text-base-content/70 mt-1">
        Browse and join interactive live sessions in
        {{ currentTenant?.name || 'our academy' }}
      </p>
    </div>
    @if (pagination.totalDocs > 0) {
      <div
        class="daisy-badge daisy-badge-primary daisy-badge-outline font-medium px-3 py-3 gap-1.5"
      >
        <i class="fa-solid fa-tower-broadcast text-xs"></i>
        <span
          >{{ pagination.totalDocs }} Active
          {{ pagination.totalDocs === 1 ? 'Class' : 'Classes' }}</span
        >
      </div>
    }
  </div>

  <!-- Loading State -->
  @if (isLoading && liveClassCards.length === 0) {
    <div class="flex flex-col items-center justify-center py-20">
      <span
        class="daisy-loading daisy-loading-spinner daisy-loading-lg text-primary"
      ></span>
      <p class="text-sm text-base-content/60 mt-4">Loading classes...</p>
    </div>
  } @else {
    <!-- Classes Grid -->
    <div
      class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6"
    >
      @for (card of liveClassCards; track card.id) {
        <div
          class="h-full transition-transform duration-200 hover:-translate-y-1"
        >
          <black-ui-card
            [data]="card"
            (clickMoreDetails)="onClickLiveClass($event)"
            (clickContinueLearning)="onClickContinue($event)"
            (clickAccessResources)="onClickAccessResources($event)"
            (clickJoinMeetings)="onClickJoinMeetings($event)"
            (clickEnroll)="onClickSubscribe($event)"
          ></black-ui-card>
        </div>
      } @empty {
        <!-- Empty State -->
        <div
          class="col-span-full flex flex-col items-center justify-center py-16 px-6 bg-base-100 rounded-2xl border border-base-300 shadow-sm text-center max-w-lg mx-auto"
        >
          <div
            class="w-16 h-16 rounded-full bg-base-200 flex items-center justify-center mb-4 text-base-content/40"
          >
            <i class="fa-solid fa-video-slash text-2xl"></i>
          </div>
          <h3 class="text-lg font-bold text-base-content mb-1">
            No Live Classes Available
          </h3>
          <p class="text-sm text-base-content/60 mb-6">
            There are currently no active live classes scheduled. Please check
            back soon!
          </p>
          <a
            routerLink="/dashboard/learning"
            class="daisy-btn daisy-btn-primary daisy-btn-sm gap-2"
          >
            <i class="fa-solid fa-chalkboard-user"></i>
            Go to My Classes
          </a>
        </div>
      }
    </div>

    <!-- Pagination -->
    @if (pagination.totalPages > 1) {
      <div
        class="bg-base-100 rounded-2xl p-4 sm:p-6 shadow-sm border border-base-300 flex justify-between items-center flex-wrap gap-4 mt-6"
      >
        <div class="text-sm text-base-content/70 font-medium">
          Page {{ pagination.page }} of {{ pagination.totalPages }} ({{
            pagination.totalDocs
          }}
          total)
        </div>

        <nav
          class="flex items-center gap-1.5"
          aria-label="Pagination Navigation"
        >
          <!-- Previous Button -->
          <button
            class="daisy-btn daisy-btn-sm daisy-btn-outline gap-1 rounded-xl disabled:opacity-50"
            [disabled]="!pagination.hasPrevPage"
            (click)="paginateItems(pagination.page - 1)"
          >
            <i class="fa-solid fa-chevron-left text-xs"></i>
            <span class="hidden sm:inline">Previous</span>
          </button>

          <!-- Page Numbers -->
          @for (
            item of createRange(pagination.totalPages, pagination.page);
            track item
          ) {
            @if (item >= pagination.page - 2 && item <= pagination.page + 2) {
              <button
                class="daisy-btn daisy-btn-sm rounded-xl font-bold"
                [class.daisy-btn-primary]="pagination.page === item"
                [class.daisy-btn-ghost]="pagination.page !== item"
                (click)="paginateItems(item)"
              >
                {{ item }}
              </button>
            }
          }

          <!-- Next Button -->
          <button
            class="daisy-btn daisy-btn-sm daisy-btn-outline gap-1 rounded-xl disabled:opacity-50"
            [disabled]="!pagination.hasNextPage"
            (click)="paginateItems(pagination.page + 1)"
          >
            <span class="hidden sm:inline">Next</span>
            <i class="fa-solid fa-chevron-right text-xs"></i>
          </button>
        </nav>
      </div>
    }
  }
</div>
